export default "__VITE_ASSET__B0qIcBop__"